import { useCallback, useEffect, useState } from "react"
import { useIntl } from "react-intl"

import dayjs, { Dayjs } from "dayjs"

import { StaffBodyTextXS } from "@doktor-se/bones-ui"

import BannerContainer from "components/banners/BannerContainer"

interface TokenWarningProps {
  exp: Dayjs
  logout: () => void
}

const TokenWarning = ({ logout, exp }: TokenWarningProps) => {
  const calcTime = useCallback(() => dayjs(exp).diff(dayjs(), "minutes"), [exp])
  const [time, setTime] = useState(calcTime())
  const intl = useIntl()

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(calcTime())
    }, 10000)
    return () => clearInterval(interval)
  }, [calcTime])

  return (
    <BannerContainer>
      <StaffBodyTextXS>{intl.formatMessage({ id: "warning.auth.time" }, { time })}</StaffBodyTextXS>
      <button className="banner-action" onClick={() => logout()}>
        <StaffBodyTextXS>{intl.formatMessage({ id: "warning.auth.link" })}</StaffBodyTextXS>
      </button>
      <StaffBodyTextXS>{intl.formatMessage({ id: "warning.auth.login" })}</StaffBodyTextXS>
    </BannerContainer>
  )
}

export default TokenWarning
